window.HGW = window.HGW || {};

HGW.calendar = {
  open(ctx) {
    this.render(ctx);
    if (ctx.calendar) ctx.calendar.style.display = "block";
  },

  close(ctx) {
    if (ctx.calendar) ctx.calendar.style.display = "none";
  },

  render(ctx) {
    const wrapper = ctx.calendar;
    if (!wrapper) return;

    // ✅ mount가 있으면 달력은 mount에만 렌더 (옵션/서명 UI 보호)
    const mount = ctx.mount || wrapper;

    // mount만 비우기
    mount.innerHTML = "";

    const mode = ctx.mode || "pickup"; // pickup | delivery

    const state = HGW.state.get();
    const today = HGW.utils.startOfDay(new Date());

    /* =========================
      DELIVERY RANGE CONTROL
    ========================= */

    const minDateISO = ctx.minDate || null;
    const minDate = minDateISO ? HGW.utils.parseISOLocal(minDateISO) : null;

    // pickup은 기존 14일 유지
    const maxDays = Number(ctx.maxDays || 14);

    const policy = HGW.deliveryPolicy;

    const dispatchEnabledDays =
      policy?.dispatch_enabled_days || ["mon","tue","wed","thu","fri"];

    const weekdayMap = ["sun","mon","tue","wed","thu","fri","sat"];

    /* =========================
       PICKUP MODE SETUP
    ========================= */

    const storeCode = ctx.storeSelect?.value;
    const store = HGW.core?.getStoreByCode ? HGW.core.getStoreByCode(storeCode) : null;

    const hasStore = mode === "pickup" ? Boolean(store) : true;
    const hasSchedule = mode === "pickup" ? Boolean(HGW.schedule?.buildSlots) : true;

    const notice = document.createElement("div");
    notice.className = "hgw-calendar-notice";
    notice.style.display = "none";

    let baseDate = null;
    let orderClosedToday = false;

    /* =========================
       PICKUP BASE DATE LOGIC
    ========================= */

    if (mode === "pickup" && hasStore && hasSchedule) {
      if (store?.holiday?.note) {
        notice.textContent = store.holiday.note;
        notice.style.display = "block";
      }

      for (let i = 0; i <= 7; i++) {
        const d = HGW.utils.addDays(today, i);
        const iso = HGW.utils.formatISO(d);

        const slots = HGW.schedule.buildSlots({ store, dateStr: iso });

        if (i === 0 && Array.isArray(slots) && slots.every((s) => s.disabled)) {
          orderClosedToday = true;
        }

        if (Array.isArray(slots) && slots.some((s) => !s.disabled)) {
          baseDate = d;
          break;
        }
      }

      if (orderClosedToday) {
        notice.textContent =
          "Same-day pickup is no longer available. Orders placed after the cutoff time will be scheduled from tomorrow.";
        notice.style.display = "block";
      }

      if (!baseDate) {
        mount.appendChild(notice);
        mount.insertAdjacentHTML("beforeend", "<div class='hgw-empty'>No available pickup dates</div>");
        return;
      }
    }

    /* =========================
       ALLOWED DATE RANGE
    ========================= */

    const allowedISOs =
      mode === "pickup" && baseDate
        ? new Set([0, 1, 2].map((offset) => HGW.utils.formatISO(HGW.utils.addDays(baseDate, offset))))
        : null;

    /* =========================
      START BASE DATE
    ========================= */

    let startBase = today;

    // delivery일 때만 minDate 기준으로 이동
    if (mode === "delivery" && minDate) {
      startBase = minDate;
    }

    const start = new Date(startBase);
    start.setDate(startBase.getDate() - startBase.getDay());

    const month = document.createElement("div");
    month.className = "hgw-calendar-month";
    month.textContent = start.toLocaleDateString("en-AU", { month: "long", year: "numeric" });
    mount.appendChild(month);

    const weekdays = document.createElement("div");
    weekdays.className = "hgw-calendar-weekdays";

    ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"].forEach((d) => {
      const el = document.createElement("div");
      el.textContent = d;
      weekdays.appendChild(el);
    });

    mount.appendChild(weekdays);

    const grid = document.createElement("div");
    grid.className = "hgw-calendar-grid";

    /* =========================
       DATE GRID
    ========================= */

    const totalDays = mode === "delivery" ? maxDays : 14;

    for (let i = 0; i < totalDays; i++) {
      const d = new Date(start);
      d.setDate(start.getDate() + i);

      const iso = HGW.utils.formatISO(d);

      const btn = document.createElement("button");
      btn.type = "button";
      btn.className = "hgw-calendar-day";
      btn.dataset.value = iso;
      btn.textContent = d.getDate();

      let disabled = false;

      // 과거 날짜 차단
      if (d < today) disabled = true;

      // delivery 최소 출발일 이전 차단
      if (mode === "delivery" && minDate && d < minDate) {
        disabled = true;
      }

      /* =========================
         DELIVERY MODE RULES
      ========================= */

      if (mode === "delivery") {

        const now = new Date();
        const cutoffHour = 12;

        const weekdayKey = weekdayMap[d.getDay()];

        // dispatch_enabled_days 정책 적용
        if (!dispatchEnabledDays.includes(weekdayKey)) {
          disabled = true;
        }

        // 오늘 cutoff 이후 차단
        const isToday =
          d.getFullYear() === now.getFullYear() &&
          d.getMonth() === now.getMonth() &&
          d.getDate() === now.getDate();

        if (isToday && now.getHours() >= cutoffHour) {
          disabled = true;
          btn.title = "Same-day dispatch cutoff is 12:00 PM";
        }

      }

      /* =========================
         PICKUP MODE RULES
      ========================= */

      if (mode === "pickup") {
        if (!hasStore || !hasSchedule) {
          disabled = true;
        } else if (allowedISOs && !allowedISOs.has(iso)) {
          disabled = true;
        }

        if (store?.holiday?.dates && store.holiday.dates.includes(iso)) {
          disabled = true;
        }
      }

      if (disabled) {
        btn.disabled = true;
        btn.classList.add("is-disabled");
      }

      if (mode === "pickup" && baseDate && iso === HGW.utils.formatISO(baseDate)) {
        btn.classList.add("is-earliest");
      }

      const selectedDate = mode === "pickup" ? state.date : state.delivery?.dispatch_date;
      if (selectedDate === iso) btn.classList.add("is-selected");

      // ✅ 날짜 클릭 이벤트 (이게 핵심)
      btn.addEventListener("click", () => {
        if (btn.disabled) return;

        const isoValue = btn.dataset.value;
        const current = HGW.state.get();

        if (mode === "pickup") {
          HGW.state.update({ date: isoValue });
        } else {
          const del = current.delivery || {};
          HGW.state.update({
            delivery: {
              ...del,
              dispatch_date: isoValue
            }
          });
        }

        // 선택 표시 업데이트 (재렌더 없이)
        mount.querySelectorAll(".hgw-calendar-day").forEach((el) => el.classList.remove("is-selected"));
        btn.classList.add("is-selected");

        HGW.core?.validate?.();
        HGW.core?.renderDeliverySummary?.();
      });

      grid.appendChild(btn);
    }

    mount.appendChild(grid);

    if (mode === "pickup" && orderClosedToday) {
      notice.innerHTML =
        "Same-day pickup is no longer available. <br>Orders placed after the cutoff time will be scheduled from tomorrow.";
      notice.style.display = "block";
      mount.appendChild(notice);
    } else if (mode === "pickup" && notice.style.display === "block") {
      mount.appendChild(notice);
    }
  }
};